import { render, staticRenderFns } from "./distributionBatchList.vue?vue&type=template&id=20fee049&scoped=true&"
import script from "./distributionBatchList.vue?vue&type=script&lang=js&"
export * from "./distributionBatchList.vue?vue&type=script&lang=js&"
import style0 from "./distributionBatchList.vue?vue&type=style&index=0&id=20fee049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fee049",
  null
  
)

export default component.exports